import type { Buffer } from "./buffer";
import type { Cursor } from "./cursor";

export interface Snapshot {
  readonly buffer: Buffer;
  readonly cursor: Cursor;
}

export interface History {
  readonly undoStack: readonly Snapshot[];
  readonly redoStack: readonly Snapshot[];
}

export const EMPTY_HISTORY: History = { undoStack: [], redoStack: [] };

/** 変更の直前に呼ぶ。スナップショットをundoStackへ積み、redoStackを空にする（ADR-003）。 */
export function pushUndoSnapshot(history: History, snapshot: Snapshot): History {
  return { undoStack: [...history.undoStack, snapshot], redoStack: [] };
}

export function popUndo(history: History): { snapshot: Snapshot; history: History } | null {
  const last = history.undoStack[history.undoStack.length - 1];
  if (!last) {
    return null;
  }
  return {
    snapshot: last,
    history: { undoStack: history.undoStack.slice(0, -1), redoStack: history.redoStack },
  };
}

export function popRedo(history: History): { snapshot: Snapshot; history: History } | null {
  const last = history.redoStack[history.redoStack.length - 1];
  if (!last) {
    return null;
  }
  return {
    snapshot: last,
    history: { undoStack: history.undoStack, redoStack: history.redoStack.slice(0, -1) },
  };
}
